// Game options configuration
// Easy to extend with new games in the future

export const GAME_OPTIONS = [
  {
    value: 'tcg',
    label: 'Trading Card Game',
    icon: 'fas fa-layer-group',
    color: '#E63946',
    description: 'Track TCG matches and decks'
  },
  {
    value: 'vgc',
    label: 'Video Game',
    icon: 'fas fa-gamepad',
    color: '#2196F3',
    description: 'Track VGC battles and teams'
  }
  // Future games can be added here:
  // {
  //   value: 'go',
  //   label: 'Pokémon GO',
  //   icon: 'fas fa-mobile-alt',
  //   color: '#4CAF50',
  //   description: 'Track GO battles and raids'
  // },
  // {
  //   value: 'unite',
  //   label: 'Pokémon UNITE',
  //   icon: 'fas fa-users',
  //   color: '#9C27B0',
  //   description: 'Track UNITE matches'
  // }
];

// Helper function to get game option by value
export const getGameOption = (value) => {
  return GAME_OPTIONS.find(option => option.value === value);
};

// Helper function to get multiple game options by values
export const getGameOptions = (values) => {
  return GAME_OPTIONS.filter(option => values.includes(option.value));
};

// Helper function to get all game values
export const getAllGameValues = () => {
  return GAME_OPTIONS.map(option => option.value);
};

// Helper function to validate game preferences
export const validateGamePreferences = (preferences) => {
  // Ensure at least one game is selected
  const selectedGames = Object.keys(preferences).filter(key => preferences[key]);
  return selectedGames.length > 0;
};